module.exports = __webpack_public_path__ + "static/sydneygif-80e183e97b89be6242a17b418effd635.gif";